<template>
    <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
            <span v-on="on">
                <template v-if="getSignatureFromBuyer(sale, sale.buyers[0])">
                    {{ getSignatureFromBuyer(sale, sale.buyers[0]).notificationSent | toDate() }}
                </template>
                <template v-else>
                    --/--/----
                </template>
            </span>
        </template>

        <v-list>
            <v-list-item v-for="buyer of sale.buyers" :key="`${buyer.id}-${buyer.type}`">
                <v-list-item-content>
                    <v-list-item-title>
                        {{ buyer.name }} {{ buyer.firstname }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                        <template v-if="getSignatureFromBuyer(sale, buyer)">
                            {{ getSignatureFromBuyer(sale, buyer).notificationSent | toDate() }}
                        </template>
                        <template v-else>
                            --/--/----
                        </template>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import salesMixin from '../../../mixins/sales.js';

export default {
    name: 'BuyersSRUSent',

    mixins: [salesMixin],

    props: {
        sale: { type: Object, required: true }
    }
};
</script>